import PaigeClaims from "./PaigeClaims";

export default PaigeClaims;
